import BlockPadding from '@/components/block-padding';
import { Hero } from '@bumble/ui-kit';

export default function IndexHero({ data }: { data: any }) {
  const { title, description } = data || {};

  return (
    <BlockPadding maxWidth="large">
      <div style={{ textAlign: 'center', padding: '40px 0' }}>
        <Hero
          variant="cta"
          backgroundColor="white"
          ctaBox={{
            title,
            description,
          }}
          spacing="compact"
        />
      </div>
    </BlockPadding>
  );
}
